import {
  Handshake,
  Key,
  ShieldCheck,
  Sparkles,
  Wallet,
  Zap,
} from "lucide-react";

const DIFERENCIAIS = [
  {
    icon: Zap,
    title: "Lastro em operação real",
    desc: "Produto de crédito estruturado lastreado em aluguel de eletrônicos por assinatura — não é promessa, é operação mensurável.",
  },
  {
    icon: ShieldCheck,
    title: "Estrutura completa",
    desc: "Divulgação, backoffice e compliance prontos, para você focar no relacionamento com seus clientes.",
  },
  {
    icon: Handshake,
    title: "Modelo fiduciário",
    desc: "Produto que complementa — e não conflita — com sua atuação independente e transparente.",
  },
  {
    icon: Key,
    title: "Liberdade total",
    desc: "Atue sem exclusividade. Você decide quando, como e para quem oferecer.",
  },
  {
    icon: Sparkles,
    title: "Suporte comercial direto",
    desc: "Material de apresentação, treinamento de produto e um time dedicado ao pós-venda.",
  },
  {
    icon: Wallet,
    title: "Remuneração por resultado",
    desc: "Comissão competitiva, acima da média do mercado, com base no volume divulgado.",
  },
];

export const AssessoresDiferenciais = () => {
  return (
    <section id="diferenciais" className="bg-[#FAF8F5] py-16 sm:py-20 md:py-24">
      <div className="container-wide px-6 sm:px-6 md:px-12">
        <div className="max-w-2xl">
          <span className="inline-flex items-center rounded-full bg-[#34F285]/[0.06] px-4 py-1.5 text-xs font-medium text-[#1F3D2E] ring-1 ring-[#1F3D2E]/10">
            Por que a Allu
          </span>
          <h2
            className="mt-6 font-extrabold leading-[1.1] tracking-tight text-[#323F4F] text-3xl sm:text-4xl md:text-5xl"
            style={{
              fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
            }}
          >
            Por que profissionais independentes escolhem a Allu.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed">
            Uma estrutura construída para respeitar sua autonomia e
            potencializar seus resultados.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {DIFERENCIAIS.map((d) => (
            <div
              key={d.title}
              className="bg-white rounded-2xl p-6 shadow-[0_8px_30px_-12px_rgba(50,63,79,0.15)] hover:shadow-[0_12px_36px_-12px_rgba(50,63,79,0.22)] transition-shadow"
            >
              <div className="w-10 h-10 rounded-xl bg-[#34F285]/[0.08] flex items-center justify-center">
                <d.icon className="w-5 h-5 text-[#2E694D]" />
              </div>
              <h3
                className="mt-4 text-base font-extrabold text-[#323F4F] tracking-tight"
                style={{
                  fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                }}
              >
                {d.title}
              </h3>
              <p className="mt-1.5 text-sm text-zinc-600 leading-relaxed">
                {d.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
